import ApiKeyEditorStore from '../../stores/api-key-editor-store';
import './action-list.scss';
import CopyApiKeyButton from './copy-api-key-button/copy-api-key-button';
import DeleteApiKeyButton from './delete-api-key-button/delete-api-key-button';
import EditApiKeyButton from './edit-api-key-button/edit-api-key-button';

interface ActionListProps {
    apiKey: ApiKeyEditorStore;
    isDisabled: boolean;
    onRemove: (apiKey: ApiKeyEditorStore) => void;
}

const ActionList: React.FC<ActionListProps> = ({ apiKey, isDisabled, onRemove }) => {
    return (
        <span className='action-list'>
            <CopyApiKeyButton apiKey={apiKey.api_key} isDisabled={isDisabled} />
            <EditApiKeyButton integrationsConnectionId={apiKey.integrations_connection_id} isDisabled={isDisabled} />
            <DeleteApiKeyButton apiKey={apiKey} isDisabled={isDisabled} onClick={onRemove} />
        </span>
    );
};

export default ActionList;
